import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Auth } from 'aws-amplify';
import { LeftGrid, PrintButtonGrid } from '../../Episode.Styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useForm } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import {
  EPISODE_ORAS_RT,
  EPISODE_ORAS_RT_DELETE_URL,
  formDateFormat
} from '../../../../constants';
import { getStopApi, postStopApi, deleteStopApi } from '../../../../services/StopApi/StopApi';
import { getContactByUser } from '../../../Contact/services/contactsApi';
import FormInputText from '../../../common/Forms/FormTextField';
import FormInputDropdown from '../../../common/Forms/FormDropdown';
import moment from 'moment';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import FormInputMultiCheckbox from '../../../common/Forms/FormCheckbox';
import FormInputRadio from '../../../common/Forms/FormRadio';
import RTScoringGuide from './RTScoringGuide';
import ScoringTool from '../../../../rptOrasRT_Scoring.pdf'

const RT = () => {
	const [openScoringGuide, setOpenScoringGuide] = useState(false);
	const [user, setUser] = useState(null);
	const [oras, setOras] = useState(null);
	const [isOverride, setIsOverride] = useState(false);
	const [overrideLevel, setOverrideLevel] = useState();
	const [successMessage, setSuccessMessage] = useState(false);
	const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
	const episode = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]
  );
  //console.log('### episode');
  //console.log(episode);

  const participantInfo = useSelector(
    (state) => state?.participants?.participantsDetail[0]
  );
  //console.log('### participantInfo');
  //console.log(participantInfo);

  const aorcmReferenceData = useSelector((state) => state.aorcmReferenceData);
  //console.log('### aorcmReferenceData');
  //console.log(aorcmReferenceData);

  const [tot1, setTot1] = useState();
  const [tot2, setTot2] = useState();
  const [tot3, setTot3] = useState();
  const [totRT, setTotRT] = useState();

  const defaultValues = {
  	age: '',
    q1_1: '',
    q1_2: '',
    q1_3: '',
    q1_4: '',
    q1_5: '',
    q1_6: '',
    q1_7: '',
    q1_8: '',
    q2_1: '',
    q2_2: '',
    q2_3: '',
    q2_4: '',
    q3_1: '',
    q3_2: '',
    q3_3: '',
    q3_4: '',
    q3_5: '',
    q3_6: '',
    q3_7: '',
    epdOrasAssessDate: null,
    epdOrasCSSID: null,
    isOverride: false,
    other_LowIntelligence: false,
    other_PhysicalHandicap: false,
    other_ReadWriteLimits: false,
    other_MentalHealth: false,
    other_NoDesire: false,
    other_Transportation: false,
    other_ChildCare: false,
    other_Language: false,
    other_Ethnicity: false,
    other_Cultural: false,
    other_HistoryAbuse: false,
    other_Interpersonal: false,
    other_Other: false,
    other_OtherDescr: null,

  }

	const { register, watch, handleSubmit, reset, control, formState: { errors } } = useForm({defaultValues: defaultValues});

	React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
    	//console.log(value)
    	setTot1(
    		Number(value.age ?? 0) + 
    		Number(value.q1_1 ?? 0) + 
    		Number(value.q1_2 ?? 0) + 
    		Number(value.q1_3 ?? 0) + 
    		Number(value.q1_4 ?? 0) + 
    		Number(value.q1_5 ?? 0) + 
    		Number(value.q1_6 ?? 0) +
    		Number(value.q1_7 ?? 0) +
    		Number(value.q1_8 ?? 0)
      );
    	setTot2(
    		Number(value.q2_1 ?? 0) + 
    		Number(value.q2_2 ?? 0) + 
    		Number(value.q2_3 ?? 0) + 
    		Number(value.q2_4 ?? 0)
      );
    	setTot3(
    		Number(value.q3_1 ?? 0) + 
    		Number(value.q3_2 ?? 0) + 
    		Number(value.q3_3 ?? 0) + 
    		Number(value.q3_4 ?? 0) + 
    		Number(value.q3_5 ?? 0) +
    		Number(value.q3_6 ?? 0) +
    		Number(value.q3_7 ?? 0)
      );
      setTotRT(
    		Number(value.age ?? 0) + 
    		Number(value.q1_1 ?? 0) + 
    		Number(value.q1_2 ?? 0) + 
    		Number(value.q1_3 ?? 0) + 
    		Number(value.q1_4 ?? 0) + 
    		Number(value.q1_5 ?? 0) + 
    		Number(value.q1_6 ?? 0) +
    		Number(value.q1_7 ?? 0) +
    		Number(value.q1_8 ?? 0) +
    		Number(value.q2_1 ?? 0) + 
    		Number(value.q2_2 ?? 0) + 
    		Number(value.q2_3 ?? 0) + 
    		Number(value.q2_4 ?? 0) +
    		Number(value.q3_1 ?? 0) + 
    		Number(value.q3_2 ?? 0) + 
    		Number(value.q3_3 ?? 0) + 
    		Number(value.q3_4 ?? 0) + 
    		Number(value.q3_5 ?? 0) +
    		Number(value.q3_6 ?? 0) +
    		Number(value.q3_7 ?? 0)

      );

    });	
     return () => subscription.unsubscribe();
  }, [watch]);

	const onFormSubmit = (payload) => {
		const url = `${EPISODE_ORAS_RT}`;
  	const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

  	payload.EpdID = episode.episodeID;
  	//console.log(payload)
  	postStopApi({ url, payload, authorization }).then((response) => {
  		fetchData();
  		setSuccessMessage(true)
  	}).catch((e) => alert(e));
	}
	
  const closeSuccessMessage = () => setSuccessMessage(false);

	const onErrors = () => {
    alert('Unable to Save. Please check for field validation errors.')
  }

	useEffect(() => {
    const initUser = async () => {
      const userData = await getUser();
      setUser(userData);
    };

    if (!user) {
      initUser();
    } else if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
  }, [user]);

  const fetchData = async () => {
    const commonParams = `${EPISODE_ORAS_RT}/${episode.episodeId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const response = await getStopApi({ commonParams, authorization });
    if (response?.data) {
     	const oras = {
     									...response.data,
     									epdOrasAssessDate: response.data.epdOrasAssessDate ? moment(response.data.epdOrasAssessDate).format(formDateFormat) : '',

     							 };
      console.log('### RT oras')
     	console.log(oras)
     	setOras(oras);
     	setIsOverride(oras.isOverride);
     	setOverrideLevel(oras.overrideLevel);
     	reset(oras);

    }
  };

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      try {
        const loggedInContact = await getContactByUser(user);
        user.contact = loggedInContact;
        //console.log('### user auth lock');
        //console.log(user.contact.authLock);
      } catch (error) {
        console.log('Error fetching contact');
      }
      return user;
    } catch (error) {
      console.log('Not signed in');
      return null;
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this ORAS RT record?')) {
      return;
    }

    const url = `${EPISODE_ORAS_RT_DELETE_URL}/${oras.epdOrasRTID}`;
    const payload = {};
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    deleteStopApi({ url, payload, authorization })
      .then((response) => {
        console.log('### delete response');
        console.log(response);
        // Clear form and return to add mode
        setOras(null);
        reset(defaultValues);
        setSuccessMessage(true);
      })
      .catch((e) => alert(e));
  };

	return (
  	<>
    	<PrintButtonGrid container>
      	<Grid item>
          	<Box>
          		{user?.contact?.authLock === true && oras?.epdOrasRTID && (
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
              >
                Delete
              </Button>
            )}&nbsp;
            	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before printing');		
              			}
              			else {
              				handlePrint();
              			}
              		}}
            	>
              		Print
            	</Button>&nbsp;
            	<a
				        href={ScoringTool}
				        download="Scoring Tool"
				        target="_blank"
				        rel="noreferrer"
				      >
	            	<Button
	              		variant="contained"
	            	>
	              		Scoring Tool
	            	</Button>
	            </a>&nbsp;	
            	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before entering scoring guide')			
              			}
              			else {
              				handleSubmit(onFormSubmit, onErrors)();
                			setOpenScoringGuide(true);
                		}	
              		}}
            	>
              		Scoring Guide
            	</Button>
          	</Box>
      	</Grid>
    	</PrintButtonGrid>

      <form onSubmit={handleSubmit(onFormSubmit, onErrors)}>
	    	<Box pt={4} px={8} ref={componentRef}>  
		      

        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Box style={{ alignItems: 'center' }}>
              <Typography variant="h4" align="center">
                ORAS Scoring for the Community Supervision Tool RT
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={7}>
            <Typography variant='h5'>Name: {participantInfo.key}</Typography>
          </Grid>
          <LeftGrid item xs={12} sm={5}>
            <Typography variant="h5" align="center">
              Date of Assessment:
            </Typography>

			<FormInputText
              name="epdOrasAssessDate"
              type="date"
              control={control}
              label=""
              register={register('epdOrasAssessDate', { required: "Required" })}
            />
           	<Typography sx={{color: 'red'}}>{errors?.epdOrasAssessDate && errors.epdOrasAssessDate.message}</Typography>

          </LeftGrid>
          <Grid item xs={12} sm={6}>
            <Typography variant='h5'>CDC #: {episode.cDCNumber}</Typography>
          </Grid>
          <LeftGrid item xs={12} sm={6}>
            <Typography sx={{margin: '8px'}} variant="h5" align="center">
              Community Service Specialist:
            </Typography>

            <FormInputDropdown
              name="epdOrasCSSID"
              getIdValue={true}
              control={control}
              options={aorcmReferenceData?.caseManagerOrCMList}
              label=""
              register={register('epdOrasCSSID', { required: "Required" })}
            /> 	
           	<Typography sx={{color: 'red'}}>{errors?.epdOrasCSSID && errors.epdOrasCSSID.message}</Typography>

          
          </LeftGrid>
        </Grid>

		      {/** Criminal History **/}
		      <Box pt={0}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650 }} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>1.0 Criminal History</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	Age at Time of Assessment - 0=24+, 1=18-23
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="age"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - 24+'},
					              	{id: 1, value: '1 - 18-23'},
					              ]}
					              label=""
					              register={register('age', { required: "Required" })}
					            /> 	

			              	<Typography sx={{color: 'red'}}>{errors?.age && errors.age.message}</Typography>
			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.1 Most Serious Arrest Under Age 18

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - Yes, Misdemeanor'},
					              	{id: 2, value: '2 - Yes, Felony'},					              	
					              ]}
					              label=""
					              register={register('q1_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_1 && errors.q1_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.2 Age at First Arrest or Charge

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - 26 or Greater'},
					              	{id: 1, value: '1 - 16 to 25'},
					              	{id: 2, value: '2 - 15 or Younger'},
					              ]}
					              label=""
					              register={register('q1_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_2 && errors.q1_2.message}</Typography>
			              	
			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.3 Prior Commitment as a Juvenile to Department of Youth Services

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_3 && errors.q1_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.4 Current Offense Drug Related

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_4 && errors.q1_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.5 Number of Prior Adult Felony Convictions 

			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - One or Two'},
					              	{id: 2, value: '2 - Three or More'},
					              ]}
					              label=""
					              register={register('q1_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_5 && errors.q1_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.6 Number of Prior Commitments to Prison
	
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_6"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - One'},
					              	{id: 2, value: '2 - Two or More'},
					              ]}
					              label=""
					              register={register('q1_6', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_6 && errors.q1_6.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.7 Ever Received Official Infraction for Violence While Incarcerated as an Adult
	
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_7"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_7', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_7 && errors.q1_7.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.8 Ever Absconded from Community Supervision as an Adult
	
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_8"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_8', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_8 && errors.q1_8.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Criminal History</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot1 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>  

		      {/** Education, Employment and Social Support **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>2.0 Education, Employment and Social Support</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.1 Ever Suspended or Expelled from School
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q2_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_1 && errors.q2_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.2 Employed at the Time of Arrest
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q2_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_2 && errors.q2_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.3 Ever Quit a Job Prior to Having Another One
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q2_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_3 && errors.q2_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.4 Marital Status 
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Married or Cohabitating with a Significant Other'},
					              	{id: 1, value: '1 - Single, Married but Separated, Divorced, or Widowed'},
					              ]}
					              label=""
					              register={register('q2_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_4 && errors.q2_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Education, Employment and Social Support</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot2 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Criminal Attitudes and Behavioral Patterns **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>3.0 Criminal Attitudes and Behavioral Patterns</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.1 Criminal Attitudes
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No/Limited'},
					              	{id: 1, value: '1 - Some Criminal Attitudes'},
					              	{id: 2, value: '2 - Significant Criminal Attitudes'},
					              ]}
					              label=""
					              register={register('q3_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_1 && errors.q3_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.2 Believes that it is Possible to Overcome Past
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q3_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_2 && errors.q3_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.3 Uses Anger to Intimidate Others
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q3_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_3 && errors.q3_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.4 Walks Away from a Fight
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - Sometimes'},
					              	{id: 2, value: '2 - Rarely'},
					              ]}
					              label=""
					              register={register('q3_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_4 && errors.q3_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.5 Problem Solving Ability
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Good'},
					              	{id: 1, value: '1 - Poor'},
					              ]}
					              label=""
					              register={register('q3_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_5 && errors.q3_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.6 Expresses Concern About Others
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_6"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Others'},
					              	{id: 1, value: '1 - Immediate Family/Friends'},
					              	{id: 2, value: '2 - No Concern for Others'},
					              ]}
					              label=""
					              register={register('q3_6', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_6 && errors.q3_6.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.7 Believes in “Do Unto Others Before They Do Unto You”
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_7"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Disagree'},
					              	{id: 1, value: '1 - Sometimes'},
					              	{id: 2, value: '2 - Agree'},
					              ]}
					              label=""
					              register={register('q3_7', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_7 && errors.q3_7.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Criminal Attitudes and Behavioral Patterns</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot3 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Total **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Total RT Score</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>{totRT}</TableCell>
			            </TableRow>
			          </TableHead>
			        </Table>
			      </TableContainer>

			      <Box pt={4}>
			      	<Grid container spacing={2}>
			      		<Grid item xs={6}>
					        <Typography variant="h5">
					          Calculated Risk: { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
					          						(totRT ?? 0) == 0 ? '' :
		      										totRT < 10 ? 'Low' :
		      										totRT < 16 ? 'Moderate' :
		      										'High'
		      										:
					          						(totRT ?? 0) == 0 ? '' :
		      										totRT < 11 ? 'Low' :
		      										totRT < 15 ? 'Moderate' :
		      										'High'

		      								 	}
					        </Typography>
					        <Typography variant="h5">
					          Recommendations: { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
					          					!isOverride ?
					          						(totRT ?? 0) == 0 ? '' :
					          						(totRT < 10) ? 'LOW - Regular supervision recommended; programming should be provided for moderate and high need domains' :
					          						totRT < 16 ? 'MODERATE - Enhanced supervision; programmming should be provide for high need domains' :
					          						'HIGH - Enhanced supervision or residential placement recommended; programming should be provided for moderate and high need domains'
					          						:
					          						overrideLevel == 1 ? 'LOW - Regular supervision recommended; programming should be provided for moderate and high need domains' :
					          						overrideLevel == 2 ? 'MODERATE - Enhanced supervision; programmming should be provide for high need domains' :
					          						'HIGH - Enhanced supervision or residential placement recommended; programming should be provided for moderate and high need domains'
					          				:
					          					!isOverride ?
					          						(totRT ?? 0) == 0 ? '' :
					          						(totRT < 11) ? 'LOW - Regular supervision recommended; programming should be provided for moderate and high need domains' :
					          						totRT < 15 ? 'MODERATE - Enhanced supervision; programmming should be provide for high need domains' :
					          						'HIGH - Enhanced supervision or residential placement recommended; programming should be provided for moderate and high need domains'
					          						:
					          						overrideLevel == 1 ? 'LOW - Regular supervision recommended; programming should be provided for moderate and high need domains' :
					          						overrideLevel == 2 ? 'MODERATE - Enhanced supervision; programmming should be provide for high need domains' :
					          						'HIGH - Enhanced supervision or residential placement recommended; programming should be provided for moderate and high need domains'
			
					          					}
					        </Typography>
					      </Grid>
			      		<Grid item xs={6}>
			      			<FormInputMultiCheckbox
                    control={control}
                    name="isOverride"
                    label="Professional Override"
                    register={register('isOverride', {
                      onChange: (e) => {
                        setIsOverride(e.target.value);
                      },
                    })}
                  />
                  <FormInputText
	                  name='overrideReason'
	                  control={control}
	                  multiline={true}
	                  type="text"
	                  label='Override Reason'
	                  shrink={true}
	                  disabled={!isOverride}
	                />
	                <FormInputRadio
	                	isRadio={true}
	                  name='overrideLevel'
	                  control={control}
	                  options={[
	                  	{'value': 1, 'label': 'Low'},
	                  	{'value': 2, 'label': 'Moderate'},
	                  	{'value': 3, 'label': 'High'}
	                  ]}
	                  label='Override Level: &nbsp;'
	                  disabled={!isOverride}
	                  register={register('overrideLevel', {
                      onChange: (e) => {
                        setOverrideLevel(e.target.value);
                      },
                    })}
	                />
					      </Grid>
					        <Grid item xs={12}>
	                  <Typography variant="h6">
	                    Other areas of concern. Check all that apply:
	                  </Typography>
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_LowIntelligence"
	                    label="Low Intelligence"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_PhysicalHandicap"
	                    label="Physical Handicap"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_ReadWriteLimits"
	                    label="Read/Writing"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_MentalHealth"
	                    label="Mental Health"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_NoDesire"
	                    label="No Desite to Change"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Transportation"
	                    label="Transportation"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_ChildCare"
	                    label="Child Care"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Language"
	                    label="Language"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Ethnicity"
	                    label="Ethnicity"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Cultural"
	                    label="Cultural Barriers"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_HistoryAbuse"
	                    label="History of Abuse/Neglect"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Interpersonal"
	                    label="Interpersonal Anxiety"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Other"
	                    label="Other"
	                  />
	                  <FormInputText
		                  name='other_OtherDescr'
		                  control={control}
		                  type="text"
		                  label='Other Area of Concern'
		                  multiline={true}
		                  shrink={true}
		                />
	                </Grid>  
					    </Grid>  
			      </Box>
			    </Box>      

		    </Box>
		    <LeftGrid pt={4} px={12}>

		    	<Button type='submit' variant="contained">Save RT</Button>&nbsp;
            {user?.contact?.authLock === true && oras?.epdOrasRTID && (
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
              >
                Delete
              </Button>
            )}
            &nbsp;
		    	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before printing');
              			}
              			else {
              				handlePrint();
              			}
              		}}
            	>
              		Print
            	</Button>&nbsp;
            	<a
				        href={ScoringTool}
				        download="Scoring Tool"
				        target="_blank"
				        rel="noreferrer"
				      >
	            	<Button
	              		variant="contained"
	            	>
	              		Scoring Tool
	            	</Button>
	            </a>&nbsp;	
            	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before entering scoring guide')			
              			}
              			else {
              				handleSubmit(onFormSubmit, onErrors)();
                			setOpenScoringGuide(true);
                		}	
              		}}
            	>
              		Scoring Guide
            	</Button>
		    </LeftGrid>	  
		  </form>

		  <RTScoringGuide
        open={openScoringGuide}
        setOpen={setOpenScoringGuide}
        participantInfo={participantInfo}
        episode={episode}
        aorcmReferenceData={aorcmReferenceData}
        oras={oras}
        tot1={tot1}
        tot2={tot2}
        tot3={tot3}
        totORAS={totRT}
        isOverride={isOverride}
        overrideLevel={overrideLevel}
      />

	    <Snackbar 
	      open={successMessage} 
	      autoHideDuration={3000} 
	      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
	      onClose={closeSuccessMessage}
	    >
	      <Alert 
	  			severity="success"
	        onClose={closeSuccessMessage}
	      >
	      	Save Success!
	      </Alert>
	    </Snackbar>
  
		</>  	
  );	
};

export default RT;